module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "foreword",
      "id": "_idContainer004",
      "role": "doc-foreword"
    }
  }, [_c('p', {
    staticClass: "fl-fl-roman"
  }, [_c('b', [_vm._v("Terri Reed")]), _vm._v("’s romance and romantic suspense novels have appeared on the "), _c('i', [_vm._v("Publishers Weekly")]), _vm._v(" top twenty-five and Nielsen BookScan top one hundred lists, and have been featured in "), _c('i', [_vm._v("USA TODAY")]), _vm._v(", "), _c('i', [_vm._v("Christian Fiction")]), _vm._v(" magazine and "), _c('i', [_vm._v("RT Book Reviews")]), _vm._v(". Her books have been finalists for the Romance Writers of America RITA® Award and the National Readers’ Choice Award, and finalists three times for the American Christian Fiction Writers Carol Award. Contact Terri at "), _c('a', {
    attrs: {
      "href": "http://www.terrireed.com",
      "target": "_blank"
    }
  }, [_vm._v("terrireed.com")]), _vm._v(" or PO Box 19555, Portland, OR 97224.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-center"
  }, [_c('b', [_vm._v("Books by Terri Reed")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-series"
  }, [_c('b', [_vm._v("Love Inspired Suspense")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Buried Mountain Secrets")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Secret Mountain Hideout")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-miniseries"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("True Blue K-9 Unit: Brooklyn")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Explosive Situation")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-miniseries"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("True Blue K-9 Unit")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Seeking the Truth")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-miniseries"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Military K-9 Unit")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Tracking Danger ")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Mission to Protect")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-miniseries"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Classified K-9 Unit")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Guardian")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Classified K-9 Unit Christmas")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_c('span', {
    staticClass: "roman"
  }, [_vm._v("“Yuletide Stalking”")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-center"
  }, [_vm._v("Visit the Author Profile page at "), _c('a', {
    attrs: {
      "href": "http://Harlequin.com",
      "target": "_blank"
    }
  }, [_vm._v("Harlequin.com")]), _vm._v(" for more titles.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63955420","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/About_the_Author.vue
// module id = 69
// module chunks = 0